import React from "react";
import {
  Bar,
  BarChart,
  Cell,
  LabelList,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { colors, mixHex } from "../../theme/colors";
import { AnalyticsFunnelRow } from "../../types/crm";

interface FunnelChartProps {
  rows: AnalyticsFunnelRow[];
}

export function FunnelChart({ rows }: FunnelChartProps) {
  const lastIndex = Math.max(rows.length - 1, 1);

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={rows} layout="vertical" margin={{ left: 8, right: 32 }}>
        <XAxis type="number" allowDecimals={false} tick={{ fontSize: 12 }} />
        <YAxis
          type="category"
          dataKey="stage_name"
          width={150}
          tick={{ fontSize: 12 }}
        />
        <Tooltip cursor={{ fill: colors.primaryFaint }} />
        <Bar dataKey="oportunidades_count" name="Oportunidades" radius={[0, 4, 4, 0]}>
          {rows.map((row, index) => (
            <Cell
              key={row.stage_id}
              fill={mixHex(colors.primary, colors.accent, index / lastIndex)}
            />
          ))}
          <LabelList
            dataKey="oportunidades_count"
            position="right"
            style={{ fontSize: 12, fill: colors.primaryDark }}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
